export const SHOW_SUMMARIES = import.meta.env.VITE_SHOW_SUMMARIES?.toLowerCase() !== "false";
// Brief page visibility — independent flag, defaults to true (shown in both versions)
// Set VITE_SHOW_BRIEF=false to hide the Brief nav link
export const SHOW_BRIEF = import.meta.env.VITE_SHOW_BRIEF?.toLowerCase() !== "false";
// Audit page visibility — defaults to false while the graph audit tool is parked.
export const SHOW_AUDIT = import.meta.env.VITE_SHOW_AUDIT?.toLowerCase() === "true";
// Clinical visualization lab — defaults to true during trajectory/product discovery.
export const SHOW_CLINICAL_LAB = import.meta.env.VITE_SHOW_CLINICAL_LAB?.toLowerCase() !== "false";
